import { Grid } from '../../../shared/grid';
import { Swiper, SwiperSlide } from 'swiper/react';
import './Videos.scss';

import { Navigation } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export const Videos = () =>{

  return(
    <Grid row gap="lg" id={'videos'}>
      <Grid
        desktop={{col:12}}
        style={{borderBottom: '.1rem solid rgb(206, 206, 206)'}}
        className="display-flex flex-row flex-align-center flex-justify
        padding-top-2 margin-bottom-205 padding-bottom-2 faq">
          <span className="font-sans-xl text-bold" >Help Videos</span>
          <div className='helpInfo'>
            <span >
              IIA HELPDESK HOURS<br/>
              24 Hours a day, 7 days a week
            </span>
            <span >
              TOLL-FREE<br/>
              (866)224-7677
            </span>
            <span >
              LOCAL<br/>
              (616)323-1667
            </span>
            <span >
              E-MAIL<br/>
              <div role="button" tabIndex={0} style={{color: '#1675e0', cursor:'pointer'}}  onClick={()=>{window.open("https://iiahelpdesk.nwcg.gov/contact-us", '_blank', 'noopener')}} onKeyDown={(event)=>{event.key ==='Enter' && window.open("https://iiahelpdesk.nwcg.gov/contact-us", '_blank', 'noopener')}}><i className="fas fa-envelope"/> Contact Us</div>
            </span>
            <span >
              IIA HELPDESK<br/>
              <div role="button" tabIndex={0} style={{color: '#1675e0', cursor:'pointer'}} onClick={()=>{window.open("https://iiahelpdesk.nwcg.gov/", '_blank', 'noopener')}} onKeyDown={(event)=>{event.key ==='Enter' && window.open("https://iiahelpdesk.nwcg.gov/", '_blank', 'noopener')}}>IIA Helpdesk Link</div>
            </span>
          </div>
      </Grid>

      <Grid desktop={{col:12}}>
        <Swiper
          className="swiper-container"
          modules={[Navigation]}
          spaceBetween={30}
          pagination={true}
          slidesPerView={3}
          cssMode={false} 
          navigation={true} 
          mousewheel={true} 
          keyboard={true}
        >
          <SwiperSlide style ={{height: '20rem'}}>
            <div className='video-wrapper'>
              <div className="video" style={{color:'#d8d8d8'}}>
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/121FkOOn-gw?si=dR1WbcqbL9esbz9U"
                title="Fire Environment Mapping System" 
                allowFullScreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              >
              </iframe>
              </div>
              <div className="video-description">
                <span className="text-bold font-sans-lg padding-top-2">Fire Environment Mapping System</span>
                <p className="font-sans-sm" style={{fontSize:"14px"}}>This video gives a brief demo of the Fire Environment Mapping System (FEMS) interactive map.</p>
              </div>
            </div>
            </SwiperSlide>
            <SwiperSlide style ={{height: '20rem'}}>
            <div className='video-wrapper'>
              <div className="video" style={{color:'#d8d8d8'}}>
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/ieHe8e9d9XM?si=3e0_XANFycK-HbJh" 
                title="FEMS Site Collector Training"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                allowFullScreen
              ></iframe>
              </div>
              <div className="video-description">
                <span className="text-bold font-sans-lg padding-top-2">FEMS Site Collector Training</span>
                <p className="font-sans-sm" style={{fontSize:"14px"}}>This video gives a demonstration of how to input fuel moisture samples as a site collector into the Field Sample Module of FEMS.</p>
              </div>
            </div>
            </SwiperSlide>
            <SwiperSlide style ={{height: '20rem'}}>
            <div className='video-wrapper'>
              <div className="video" style={{color:'#d8d8d8'}}>
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/etiJsJFFq2M?si=3nPKyXjifWNESaJ9" 
                title="Viewing Fuel Moisture Samples in FEMS"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                allowFullScreen
              ></iframe>
              </div>
              <div className="video-description">
                <span className="text-bold font-sans-lg padding-top-2">Viewing Fuel Moisture Samples in FEMS</span>
                <p className="font-sans-sm" style={{fontSize:"14px"}}>This video is a demonstration of how to view Fuel Moisture Samples without logging in to FEMS.</p>
              </div>
            </div>
            </SwiperSlide>
            <SwiperSlide style ={{height: '20rem'}}>
            <div className='video-wrapper'>
              <div className="video" style={{color:'#d8d8d8'}}>
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/MAufSW5Q-KE?si=ZpJDyiEMID9HgoCT" 
                title="Adding and Editing a Site" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen></iframe>
              </div>
              <div className="video-description">
                <span  className="text-bold font-sans-lg padding-top-2">Adding and Editing a Site</span>
                <p  className="font-sans-sm" style={{fontSize:"14px"}}>For FEMS Field Sample Database, this is an instructional video for Area Editors and Group Editors on adding and editing sites.</p>
              </div>
            </div>
            </SwiperSlide>

            <SwiperSlide style ={{height: '20rem'}}>
            <div className='video-wrapper'>
              <div className="video" style={{color:'#d8d8d8'}}>
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/7P3bVE5y7nA?si=BfmCmpuHhUpbg1bV"
                title="Adding and Editing Contacts" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen></iframe>
              </div>
              <div className="video-description">
                <span  className="text-bold font-sans-lg padding-top-2">Adding and Editing Contacts</span>
                <p  className="font-sans-sm" style={{fontSize:"13px"}}>For FEMS Field Sample Database, this is an instructional video for Area Editors and Group Editors on adding and editing contacts.</p>
              </div>
            </div>
            </SwiperSlide>

            <SwiperSlide style ={{height: '20rem'}}>
            <div className='video-wrapper'>
              <div className="video" style={{color:'#d8d8d8'}}>
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/7xzbfVAeZlY?si=yS5o8-Mx1wjz_bbG"
                title="Adding and Editing a Group" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen></iframe>
              </div>
              <div className="video-description">
                <span  className="text-bold font-sans-lg padding-top-2">Adding and Editing a Group</span>
                <p  className="font-sans-sm" style={{fontSize:"14px"}}>For FEMS Field Sample Database, this is an instructional video for Area Editors and Group Editors on adding and editing groups.</p>
              </div>
            </div>
            </SwiperSlide>

            <SwiperSlide style ={{height: '20rem'}}>
            <div className='video-wrapper'>
              <div className="video" style={{color:'#d8d8d8'}}>
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/ByRBPakR41Y?si=58A75wsaWCAXaRkd"
                title="Area Editors Giving Access" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen></iframe>
              </div>
              <div className="video-description">
                <span  className="text-bold font-sans-lg padding-top-2">Area Editors Giving Access</span>
                <p  className="font-sans-sm" style={{fontSize:"14px"}}> For FEMS Field Sample Database, this is an instructional video for Area Editors on giving access to Group Editors and Collectors.</p>
              </div>
            </div>
            </SwiperSlide>
        </Swiper>
      </Grid>
    </Grid>
  )
};